import { useEffect } from "react";
import { wakeServers } from "@/api/client";
import { Router } from "@/router/Router";
import { AuthProvider } from "@/state/AuthProvider";
import { ChatProvider } from "@/state/ChatProvider";
import { LiveProvider } from "@/state/LiveProvider";
import { MessagingProvider } from "@/state/MessagingProvider";
import { ThemeProvider } from "@/state/ThemeProvider";
import { Layout } from "@/components/layout/Layout";
import { ROUTES } from "./routes";

export function App() {
  useEffect(() => {
    wakeServers();
  }, []);

  return (
    <ThemeProvider>
    <AuthProvider>
    <MessagingProvider>
      <LiveProvider>
        <ChatProvider>
          <Router routes={ROUTES}>
            {({ component: Page, key }) => (
              <Layout>
                <Page key={key} />
              </Layout>
            )}
          </Router>
        </ChatProvider>
      </LiveProvider>
    </MessagingProvider>
    </AuthProvider>
    </ThemeProvider>
  );
}
